import { ChannelEnum } from '@c2b/muven-commons'

interface FieldHint {
    placeholder: string;
    validate?: (value: string) => string;
}

const WOOCOMMERCE_API_PATH = '/wp-json/wc/v3'

function validateWooCommerceKey(value: string, expected: string, swapped: string, fieldName: string, swappedName: string): string {
    if (value.startsWith(expected)) {
        return ''
    }

    if (value.startsWith(swapped)) {
        return `Parece que você colou a ${swappedName} aqui. A ${fieldName} começa com ${expected}.`
    }

    return `A ${fieldName} do WooCommerce começa com ${expected}. Confira se copiou o valor inteiro.`
}

const HINTS: {[channel: string]: {[key: string]: FieldHint}} = {
    [ChannelEnum.WooCommerce]: {
        url: {
            placeholder: `https://sualoja.com.br${WOOCOMMERCE_API_PATH}`,
            validate(value) {
                if (!/^https?:\/\//i.test(value)) {
                    return 'Informe o endereço completo, começando com https://'
                }

                if (!value.replace(/\/+$/, '').toLowerCase().endsWith(WOOCOMMERCE_API_PATH)) {
                    return `A URL da API termina em ${WOOCOMMERCE_API_PATH}. Exemplo: https://sualoja.com.br${WOOCOMMERCE_API_PATH}`
                }

                return ''
            },
        },
        consumerKey: {
            placeholder: 'ck_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
            validate: (value) => validateWooCommerceKey(value, 'ck_', 'cs_', 'Consumer key', 'Consumer secret'),
        },
        consumerSecret: {
            placeholder: 'cs_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
            validate: (value) => validateWooCommerceKey(value, 'cs_', 'ck_', 'Consumer secret', 'Consumer key'),
        },
    },
}

function getHint(channelEnum: ChannelEnum, key: string): FieldHint|undefined {
    return HINTS[channelEnum] && HINTS[channelEnum][key]
}

export default {
    getPlaceholder(channelEnum: ChannelEnum, key: string): string {
        const hint = getHint(channelEnum, key)
        return hint ? hint.placeholder : ''
    },

    getFormatWarning(channelEnum: ChannelEnum, key: string, value: any): string {
        const hint = getHint(channelEnum, key)

        if (!hint || !hint.validate || typeof value !== 'string' || !value.trim()) {
            return ''
        }

        return hint.validate(value.trim())
    },

    // O ping devolve o erro da loja embrulhado: {"status":400,"message":"Request failed with status code 403"}
    isIpBlockError(message: any): boolean {
        return typeof message === 'string' && /status code 403\b|forbidden/i.test(message)
    },
}
